import React from "react";
import { 
  FaPaypal, 
  FaRupeeSign, 
  FaArrowRight, 
  FaShieldAlt 
} from "react-icons/fa";
import { SiBitcoinsv, SiGithubsponsors, SiTelegram } from "react-icons/si";
import { Link } from "react-router-dom";

const SponsorPage = () => {
  // Clean, focused gateway options (No PayLink generator, No "Donate" wording)
  const sponsorChannels = [
    {
      title: "UPI Direct",
      desc: "Instant transfer with any UPI app using dynamic QR or deep link.",
      cta: "Open UPI",
      icon: <FaRupeeSign className="text-xl" />,
      to: "/upi",
      isExternal: false,
      badge: "Instant • 0% Fee",
      badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
      accentBorder: "hover:border-emerald-400",
    },
    {
      title: "GitHub Sponsors",
      desc: "Support open-source work directly on GitHub with recurring or one-time tiers.",
      cta: "Open Sponsors",
      icon: <SiGithubsponsors className="text-xl" />,
      to: "https://github.com/sponsors/MrAbhi2k3",
      isExternal: true,
      badge: "Recurring",
      badgeColor: "bg-purple-50 text-purple-700 border-purple-200",
      accentBorder: "hover:border-purple-400",
    },
    {
      title: "PayPal",
      desc: "Support globally using a secure PayPal international checkout flow.",
      cta: "Open PayPal",
      icon: <FaPaypal className="text-xl" />,
      to: "/paypal",
      isExternal: false,
      badge: "Global",
      badgeColor: "bg-blue-50 text-blue-700 border-blue-200",
      accentBorder: "hover:border-blue-400",
    },
    {
      title: "Crypto: TRON, BTC, TON",
      desc: "Choose your network and scan the wallet QR or copy address.",
      cta: "Open Crypto",
      icon: <SiBitcoinsv className="text-xl" />,
      to: "/crypto",
      isExternal: false,
      badge: "Web3",
      badgeColor: "bg-amber-50 text-amber-700 border-amber-200",
      accentBorder: "hover:border-amber-400",
    },
  ];

  return (
    <div className="bg-[#FAF9F6] text-slate-900 min-h-[calc(100vh-140px)] py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-5xl">
        {/* Simple & Clean Header Card */}
        <div className="rounded-3xl border border-slate-200/80 bg-white p-6 sm:p-10 shadow-xs">
          <span className="text-xs uppercase font-bold tracking-wider text-indigo-600 px-3 py-1 rounded-full bg-indigo-50 border border-indigo-200">
            Developer Support
          </span>
          <h1 className="mt-3 text-3xl font-extrabold sm:text-4xl text-slate-900 tracking-tight">
            Sponsor Developer & Projects
          </h1>
          <p className="mt-2.5 max-w-2xl text-sm text-slate-600 sm:text-base leading-relaxed">
            Pick your preferred gateway. Every option below is mobile-friendly and routes directly to the developer with zero intermediary cuts.
          </p>
        </div>

        {/* Gateway Cards Grid */}
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {sponsorChannels.map((channel, idx) => {
            const cardInner = (
              <div className="p-7 h-full flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center text-slate-800 shadow-inner">
                      {channel.icon}
                    </div>
                    <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full border ${channel.badgeColor}`}>
                      {channel.badge}
                    </span>
                  </div>

                  <h3 className="text-xl font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
                    {channel.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed min-h-[44px]">
                    {channel.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-slate-100">
                  <span className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 rounded-xl text-sm font-bold text-slate-900 bg-slate-100 group-hover:bg-slate-900 group-hover:text-white transition-colors duration-200">
                    {channel.cta}
                    <FaArrowRight className="text-xs" />
                  </span>
                </div>
              </div>
            );

            return channel.isExternal ? (
              <a
                key={idx}
                href={channel.to}
                target="_blank"
                rel="noopener noreferrer"
                className={`group rounded-3xl bg-white border border-slate-200/80 shadow-xs hover:shadow-md transition-all duration-200 ${channel.accentBorder}`}
              >
                {cardInner}
              </a>
            ) : (
              <Link
                key={idx}
                to={channel.to}
                className={`group rounded-3xl bg-white border border-slate-200/80 shadow-xs hover:shadow-md transition-all duration-200 ${channel.accentBorder}`}
              >
                {cardInner}
              </Link>
            );
          })}
        </div>

        {/* Bottom Support Note */}
        <div className="mt-8 p-5 rounded-2xl border border-slate-200/80 bg-white shadow-xs flex flex-wrap items-center justify-between gap-4 text-xs text-slate-600">
          <div className="flex items-center gap-2.5">
            <FaShieldAlt className="text-base text-emerald-600" />
            <span>Direct developer sponsorship with zero hidden fees.</span>
          </div>
          <a
            href="https://t.me/MrAbhi2k3"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 font-bold text-slate-800 hover:text-indigo-600"
          >
            <SiTelegram className="text-blue-500" /> Need custom collaboration? Let&apos;s talk
          </a>
        </div>
      </div>
    </div>
  );
};

export default SponsorPage;
